// for add employee

export const RESET_REMOVE_USER_PERMISSIONS = "reset_remove_user_permissions";
export const REMOVE_USER_PERMISSIONS = "remove_user_permissions";
export const REMOVE_USER_PERMISSIONS_SUCCESS =
    "remove_user_permissions_success";
export const REMOVE_USER_PERMISSIONS_FAILURE =
    "remove_user_permissions_failure";
